import moment from "moment";
import { useEffect, useRef, useState } from "react";
import { ChangeAlertCallbackType } from "../../../Root";
import { CustomerService } from "../../../../services/CustomerService";
moment.locale("es");

export const useVipManager = (changeAlert: ChangeAlertCallbackType) => {
    const [getCustomerData, setGetCustomerData] = useState(false);
    const customerService = useRef<CustomerService>();

    const handleGet = async (value) => {
        setGetCustomerData(value);
    };

    useEffect(() => {
        customerService.current = new CustomerService(changeAlert);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return { getCustomerData, handleGet };
};
